var _defs, _rect, _g, _g2, _text, _text2, _text3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNexight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    width: 800,
    height: 450,
    role: "img",
    "aria-label": "Nexight",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nx-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a1244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c0513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nx-ac",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c084f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a4fd6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#nx-bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#c084f5",
    strokeOpacity: 0.18,
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 110,
    r: 34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 200,
    r: 34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 250,
    r: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 110,
    x2: 540,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 110,
    x2: 700,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 200,
    x2: 700,
    y2: 250
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(64,150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    rx: 14,
    fill: "url(#nx-ac)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 40,
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 700,
    fill: "#0c0513",
    textAnchor: "middle"
  }, "N"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 270,
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 56,
    fontWeight: 700,
    fill: "#ffffff"
  }, "Nexight")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 312,
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 500,
    fill: "#c084f5"
  }, "AI-Agent Analytics Platform")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 352,
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 18,
    fill: "#b9a9cf"
  }, "LangGraph \xB7 RAG \xB7 Python \xB7 Azure")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexight);
export default __webpack_public_path__ + "static/media/nexight.6981678c1e373f4095a524e65ed9b3be.svg";
export { ForwardRef as ReactComponent };